import React from "react";
import { useFieldArray } from "react-hook-form";
import SpecsheetButtonWhite from "../../button/specsheetButtonWhite/SpecsheetButtonWhite";
import "../constants/constants.css";
import InputFieldFormArray from "../inputFieldFormArray/InputFieldFormArray";
import "./Keywords.css";

export default function Fields({
  control,
  register,
  showSidebarExtraSearchOptions,
}) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "keywords",
  });

  return (
    <div className="form-wrapper">
      <ul>
        {fields.map((item, index) => {
          return (
            <li key={item.id}>
              <div className="input-container">
                <div className="inner-input-container">
                  <div className="keywords-form-wrapper">
                    <InputFieldFormArray
                      label="Keyword "
                      fieldRef={register(`keywords[${index}].value`, {})}
                      name={`keywords[${index}].value`}
                      key={item.id}
                    />
                    <button
                      className="keywords-button delete-button"
                      type="button"
                      onClick={() => {
                        remove(index);
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
        <p className="message">
          Please fill in only one keyword in each field. The words included in
          the title of the specsheets don't have to be added.
        </p>
      </ul>

      <section>
        <button
          className="append-button"
          type="button"
          onClick={() => {
            append();
          }}
        >
          Add Keyword
        </button>
      </section>

      <section className="done-section">
        <SpecsheetButtonWhite
          type="button"
          handleClick={showSidebarExtraSearchOptions}
        >
          Done
        </SpecsheetButtonWhite>
      </section>
    </div>
  );
}
